<template>
<div class="DistributionMgt">
    <keep-alive include="DistributionList">
        <router-view></router-view>
    </keep-alive>
</div>
</template>

<script>
import {initPage} from 'common/js/mixin'

export default {
    name: 'DistributionMgt',
    mixins: [initPage],
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.DistributionMgt {
}
</style>
